import React from 'react';
import ContactForm from './../contactForm/ContactForm';
import { FaEnvelope, FaPhone, FaLinkedin, FaMapMarkerAlt, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import styles from './ContactPage.module.css';

const BOOKING_URL = 'https://calendar.app.google/4YtwnKduScqcFVjc9';

const ContactPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.pageTitle}>Book Your Free Consultation</h1>
          <p className={styles.pageSubtitle}>
            Pick a time that works for you. In 30 minutes, we'll review your current setup, identify what's costing you, and map out a plan.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={styles.bookingButton}>
            <FaCalendarAlt className={styles.bookingIcon} />
            Pick a Time <FaArrowRight className={styles.bookingArrow} />
          </a>
        </div>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.formSection}>
          <div className={styles.formHeader}>
            <h2 className={styles.sectionTitle}>Prefer to Send a Message?</h2>
            <p className={styles.sectionDescription}>
              Share your project details and I'll get back to you within 24 hours.
            </p>
          </div>

          <ContactForm />
        </div>

        <div className={styles.contactSection}>
          <h2 className={styles.sectionTitle}>Direct Contact</h2>
          <p className={styles.sectionDescription}>
            Reach out directly — I respond the same day.
          </p>

          <div className={styles.contactMethods}>
            <a href="mailto:daniel@danielrayrangel.com" className={styles.contactMethod}>
              <FaEnvelope className={styles.contactIcon} />
              <div className={styles.contactInfo}>
                <span className={styles.contactLabel}>Email</span>
                <span className={styles.contactValue}>daniel@danielrayrangel.com</span>
              </div>
            </a>

            <a href="tel:+14802820569" className={styles.contactMethod}>
              <FaPhone className={styles.contactIcon} />
              <div className={styles.contactInfo}>
                <span className={styles.contactLabel}>Phone</span>
                <span className={styles.contactValue}>(480) 282-0569</span>
              </div>
            </a>

            <a href="https://www.linkedin.com/in/danielrayrangel/" target="_blank" rel="noopener noreferrer" className={styles.contactMethod}>
              <FaLinkedin className={styles.contactIcon} />
              <div className={styles.contactInfo}>
                <span className={styles.contactLabel}>LinkedIn</span>
                <span className={styles.contactValue}>Professional Profile</span>
              </div>
            </a>
          </div>

          <div className={styles.locationInfo}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <span>West Valley, Arizona & Remote Clients Worldwide</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;